<div class="modal-dialog modal-lg">
    <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title">Importação de registros em massa</h4>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
            <p>Para importar a lista de precandidatos, selecionei abaixo o arquivo (.csv) e em seguida confira os dados.</p>
            <input type="file" #importarCandidatos class="form-control" accept=".csv" (change)="importarCsv($event)">
            
            <nav *ngIf="candidatosCriticados.length > 0 || newCandidatosArray.length > 0 || candidatosDuplicados.length > 0 || candidatosEnviados.length > 0" class="mt-3">
                <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                    <a *ngIf="candidatosCriticados.length > 0" class="nav-item nav-link" [ngClass]="ativaNavValidacao == true ? 'active' : '' "
                        id="nav-validacao-tab" data-toggle="tab" href="#nav-validacao" role="tab" aria-controls="nav-validacao" aria-selected="false">
                        Validação
                    </a>
                    <a *ngIf="newCandidatosArray.length > 0 && candidatosEnviados.length === 0" class="nav-item nav-link" 
                        [ngClass]="ativaNavEnviar == true ? 'active' : '' " id="nav-enviar-tab" data-toggle="tab" href="#nav-enviar" 
                        role="tab" aria-controls="nav-enviar" aria-selected="false">
                        Enviar
                    </a>
                    <a *ngIf="candidatosDuplicados.length > 0" class="nav-item nav-link" [ngClass]="ativaNavDuplicados === true ? 'active' : '' " 
                        id="nav-duplicados-tab" data-toggle="tab" href="#nav-duplicados" role="tab" aria-controls="nav-duplicados" 
                        aria-selected="true">
                        Duplicados
                    </a>
                    <a *ngIf="candidatosEnviados.length > 0" class="nav-item nav-link" [ngClass]="ativaNavEnviados === true ? 'active' : '' " 
                        id="nav-enviados-tab" data-toggle="tab" href="#nav-enviados" role="tab" aria-controls="nav-enviados" aria-selected="true">
                        Enviados
                    </a>
                </div>
            </nav>
            
            <div *ngIf="candidatosCriticados.length > 0 || newCandidatosArray.length > 0 || candidatosDuplicados.length > 0 || candidatosEnviados.length > 0" class="tab-content" id="nav-tabContent">
                <div *ngIf="candidatosCriticados.length > 0" class="tab-pane fade" [ngClass]="ativaNavValidacao == true ? 'show active' : '' " id="nav-validacao" role="tabpanel">
                    <div class="mt-2">
                        <div class="alert alert-danger mt-2" role="alert">
                            <p class="mb-0">O(s) candidatos(s) a seguir não passaram em alguma validação.</p>
                            <p class="mb-0">Validação 1: O login é obrigatório.</p>
                            <p class="mb-0">Validação 2: O campo formularioPreenchido é obrigatório.</p>
                            <p class="mb-0">Validação 3: O cargo não foi encontrado para essa eleição.</p>
                            <p class="mb-0">Validação 4: Se houver CPF, ele deve ser válido.</p>
                            <p class="mb-0">Validação 5: A justificativa é obrigatória.</p>
                            <p class="mb-0">Validação 6: se o voto justificável for 'Sim', o parâmetro de justificativa deve ser preenchido.</p>
                        </div>
                        <table class="table table-bordered table-sm table-striped">
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>CPF</th>
                                    <th>Cargo</th>
                                    <th>Justificativa</th>
                                    <th class="text-center">Crítica</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let candidato of candidatosCriticados">
                                    <td>{{candidato.novoCandidato.nome}}</td>
                                    <td>{{candidato.novoCandidato.cpf}}</td>
                                    <td>{{candidato.novoCandidato.cargo.nome}}</td>
                                    <td>{{candidato.novoCandidato.votoJustificavel}}</td>
                                    <td>{{candidato.critica}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
    
                <div *ngIf="newCandidatosArray.length > 0" class="tab-pane fade" [ngClass]="ativaNavEnviar == true ? 'show active' : '' " id="nav-enviar" role="tabpanel">
                    <div class="mt-2">
                        <table class="table table-bordered table-sm table-striped">
                            <thead>
                                <tr>
                                    <th>Nome do candidato</th>
                                    <th>CPF</th>
                                    <th>Cargo</th>
                                    <th class="text-center">Currículo</th>
                                    <th>Justificativa</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let candidato of newCandidatosArray">
                                    <td>{{candidato.nome}}</td>
                                    <td>{{candidato.cpf}}</td>
                                    <td>{{candidato.cargo.nome}}</td>
                                    <td>{{candidato.curriculum}}</td>
                                    <td>{{candidato.votoJustificavel}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!--
                    <button *ngIf="newCandidatosArray.length > 0" class="btn-custom btn btn-success mt-3" (click)="importarList()">
                        Salvar
                    </button>
                    -->
                </div>
    
                <div *ngIf="candidatosDuplicados.length > 0" class="tab-pane fade" [ngClass]="ativaNavDuplicados === true ? 'show active' : '' " id="nav-duplicados" role="tabpanel">
                    <div class="alert alert-danger mt-2" role="alert">
                        <p class="mb-0">Os Precandidatos abaixo já estão cadastrados.</p>
                    </div>
                    <div *ngIf="candidatosDuplicados.length > 0" class="mt-2">
                        <table class="table table-bordered table-sm table-striped">
                            <thead>
                                <tr>
                                    <th>Nome do precandidato</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let candidato of candidatosDuplicados">
                                    <td>{{candidato.nome}}</td>
                                </tr>
                            </tbody>
                        </table>              
                    </div>
                </div>
    
                <div *ngIf="candidatosEnviados.length > 0" class="tab-pane fade" [ngClass]="ativaNavEnviados === true ? 'show active' : '' " id="nav-enviados" role="tabpanel">
                    <div class="mt-2">
                        <table class="table table-bordered table-sm table-striped">
                            <thead>
                                <tr>
                                    <th>Nome do precandidato</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let candidato of candidatosEnviados">
                                    <td>{{candidato.nome}}</td>
                                </tr>
                            </tbody>
                        </table>              
                    </div>
                </div>
            </div>
            <div>
                <hr>
                <!-- <small>Se necessário faça o download do arquivo modelo aqui
                    <button class="btn btn-light ml-auto mr-2 px-2 py-0 ml-2" pTooltip="Baixar modelo de documento">
                        <i class="fas fa-download fa-xs"></i>
                    </button>
                </small> -->
                <button data-dismiss="modal" class="btn-custom btn btn-success" (click)="importarList()">
                    Salvar
                </button> 
                <button class="btn-custom btn btn-light mr-2" (click)="zerarInputFile(importarCandidatos)">
                    Descartar arquivo
                </button>  
            </div>        
        </div>
    </div>
</div>